import flatten from 'lodash/flatten';
import get from 'lodash/get';
import initial from 'lodash/initial';
import isNil from 'lodash/isNil';
import last from 'lodash/last';
import omitBy from 'lodash/omitBy';
import queryString from 'query-string';
import { getFunctionName } from 'io-ts';

import type { Errors, ValidationError} from 'io-ts';
import type { Left } from 'fp-ts/lib/Either';

function stringify(v: any) {
  if (typeof v === 'function') {
    return getFunctionName(v);
  }
  if (typeof v === 'number' && !Number.isFinite(v)) {
    if (Number.isNaN(v)) {
      return 'NaN';
    }
    return v > 0 ? 'Infinity' : '-Infinity';
  }
  return JSON.stringify(v, null, 2);
}

function process(error: ValidationError) {
  const { context } = error;

  const path = flatten([
    initial(context).map((entry) => entry.key),
    `${get(last(context), 'key')}:${get(last(context), 'type.name')}` || 'NONE',
  ]).join('/');

  return {
    value: stringify(error.value),
    path,
  };
}

export default function makeReport(result: Left<Errors>) {
  return result.left.map((error) => ({
    ...(error.message ? { message: error.message } : process(error)),
    object: (get(error.context[0], 'actual') as Record<string, any>) || {},
  }));
}

export function buildQueryString(params: Record<string, any>): string {
  if (!params) return '';
  const parameters = omitBy(params, isNil);
  return queryString.stringify(parameters);
}
